import axios from "axios"
import getTrackingCookies from "../cookie/getTrackingCookies"

// Define types
type AnalyticsEventTypes = "page_view" | "button_click" | "add_to_cart" | "initiate_checkout" | "complete_checkout"

interface AnalyticsEventData {
  type: AnalyticsEventTypes

  first_name?: string
  last_name?: string
  email?: string
  test_group_index?: number

  product_data?: {
    id: string
    name: string
    slug: string
    value: string
    quantity: number
  }[]
}

type AnalyticsEventBody = AnalyticsEventData & {
  user_agent: string
  source_url: string

  tracking_id: string
  fbc: string,
  fbp: string,
}

// Sends an analytical event to the backend
const sendAnalyticsEvent = async (eventData: AnalyticsEventData) => {
  const consent = localStorage.getItem("cookieConsent")
  const block_tracking = localStorage.getItem("block_tracking")

  if (window.location.host === "theroyalkellys.com" && consent != "false" && block_tracking != "true") {

    // Get tracking cookies
    const { tracking_id, fbc, fbp } = getTrackingCookies()

    // Construct request body
    const body: AnalyticsEventBody = {
      ...eventData,
      user_agent: navigator.userAgent,
      source_url: window.location.href,

      tracking_id,
      fbc,
      fbp,
    }

    // Send the request
    try {
      const res = await axios.post("/.netlify/functions/send_analytics_event_data", body)

      return res
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

export default sendAnalyticsEvent
